import { cleanupFilename } from './alarmArchive'
import type { TArchiveEntry } from './alarmArchive'
import type { TExportErrorCode, TExportFailure } from './exportErrors'

export const ALARM_TIMEOUT_MS = 60_000

export const alarmPrefix = (alarmId: string): string =>
  `alarm-${cleanupFilename(alarmId)}/`

export const multiArchiveName = (count: number): string =>
  `alarm-reports-${count}.zip`

export type TAlarmOutcome = {
  entries: TArchiveEntry[]
  failures: TExportFailure[]
}

export const failedAlarmOutcome = (
  alarmId: string,
  cause: string,
  code: TExportErrorCode = 'REPORT_DATA_INCOMPLETE',
): TAlarmOutcome => ({
  entries: [
    { name: `${alarmPrefix(alarmId)}ERROR_report.txt`, content: cause },
  ],
  failures: [{ code, alarmId, cause }],
})

export const mergeOutcomes = (outcomes: TAlarmOutcome[]): TAlarmOutcome => ({
  entries: outcomes.flatMap(outcome => outcome.entries),
  failures: outcomes.flatMap(outcome => outcome.failures),
})
